import React from "react";

import GovernanceExceptionQueue from "@/components/governance/GovernanceExceptionQueue";

const FinanceExceptionQueue: React.FC = () => (
  <GovernanceExceptionQueue
    title="Payment Issues"
    roleScope="finance"
    subtitle="Review applications with payment, bank, approval, or finance attention issues."
    emptyCopy="No payment issues need finance attention right now."
  />
);

export default FinanceExceptionQueue;
